import React, { Component } from "react";
import { Feed } from "semantic-ui-react";
import PropTypes from "prop-types";
import FriendItem from "./FriendItem";

class FriendsList extends Component {
  render() {
    return (
      <Feed>
        {this.props.friends.map(f => FriendItem(f, this.props.history))}
      </Feed>
    );
  }
}

FriendsList.propTypes = {
  friends: PropTypes.arrayOf(
    PropTypes.shape({
      _id: PropTypes.string.isRequired,
      firstName: PropTypes.string.isRequired,
      lastName: PropTypes.string.isRequired,
      photo: PropTypes.string.isRequired
    })
  ).isRequired
};

export default FriendsList;



// WEBPACK FOOTER //
// ./src/components/FriendsList/FriendsList.js